import WebView from "./WebView";

export default WebView;
